import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4 h-full overflow-y-auto" }
const _hoisted_2 = { class: "list-decimal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", { class: "text-gray-200" }, "Création de la partie", -1)
const _hoisted_4 = {
  key: 0,
  class: "bi bi-caret-up"
}
const _hoisted_5 = {
  key: 1,
  class: "bi bi-caret-down"
}
const _hoisted_6 = {
  key: 2,
  class: "ml-5 list-disc"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode(" Ajoutez les joueurs "),
  /*#__PURE__*/_createElementVNode("p", null, " - Chaque joueur sera tiré au hasard durant la partie afin de réaliser des actions. ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", null, "Ajoutez les catégories", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode(" Choisissez la plage de gorgées "),
  /*#__PURE__*/_createElementVNode("p", null, " - Lors de chaque action les gorgées seront tiré au hasard dans la plage de gorgées choisis. ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", null, "Choisissez le nombre de tours", -1)
const _hoisted_11 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", { class: "text-gray-200" }, "Jouer", -1)
const _hoisted_14 = {
  key: 0,
  class: "bi bi-caret-up"
}
const _hoisted_15 = {
  key: 1,
  class: "bi bi-caret-down"
}
const _hoisted_16 = {
  key: 2,
  class: "ml-5 list-disc"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("li", null, " En appuyant sur la partie droite de l'écran, vous allez à la prochaine action. ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("li", null, " En appuyant sur la partie gauche de l'écran, vous allez à la dernière question. ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("li", null, " Le menu paramètres en bas à droite vous permet de visualiser les différents timers ainsi que de modifier les joueurs. ", -1)
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("b", { class: "text-gray-200" }, "Recommencer", -1)
const _hoisted_23 = {
  key: 0,
  class: "bi bi-caret-up"
}
const _hoisted_24 = {
  key: 1,
  class: "bi bi-caret-down"
}
const _hoisted_25 = {
  key: 2,
  class: "ml-5 list-disc"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("li", null, " Appuyez sur l'écran afin de retourner sur l'écran de création de partie. ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("li", null, "Voir \"Création de la partie\"", -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("b", { class: "text-gray-200" }, "Catégories", -1)
const _hoisted_31 = {
  key: 0,
  class: "bi bi-caret-up"
}
const _hoisted_32 = {
  key: 1,
  class: "bi bi-caret-down"
}
const _hoisted_33 = {
  key: 2,
  class: "ml-5 list-disc"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Actions :"),
  /*#__PURE__*/_createTextVNode(" Des défis et actions amusantes à relever avec des conséquences. ")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Boire pour boire :"),
  /*#__PURE__*/_createTextVNode(" des règles simples, buvez à chaque tour. ")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Re-découverte :"),
  /*#__PURE__*/_createTextVNode(" permet aux joueurs de découvrir davantage les autres, révélant des anecdotes inédites. ")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Sans Gêne :"),
  /*#__PURE__*/_createTextVNode(" des défis qui vous poussent hors de votre zone de confort. ")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Olé Olé :"),
  /*#__PURE__*/_createTextVNode(" des défis coquins pour une soirée plus pimentée. ")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Marijuana :"),
  /*#__PURE__*/_createTextVNode(" des défis inspirés par la culture du cannabis pour une touche de décontraction. ")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Basique :"),
  /*#__PURE__*/_createTextVNode(" des règles classiques pour compléter une partie sans besoin de complications. ")
], -1)
const _hoisted_41 = [
  _hoisted_34,
  _hoisted_35,
  _hoisted_36,
  _hoisted_37,
  _hoisted_38,
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref } from "vue";
import PrimaryLabel from "@/components/Form/Common/PrimaryLabel.vue";
import ModalText from "@/components/Texts/ModalText.vue";
import BottomSheet from "@/components/Modals/BottomSheet.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HelperModal',
  props: {
    dialogId: {}
  },
  setup(__props: any) {

/* Inspiré de : https://play.vuejs.org/#eNp9UstOwzAQ/BXjCyDRBKniUtKKh3qAAyDo0ZfgblO3jm3Zm7RV1X9nHUelSKineGdnxrMb7/mjc1nbAB/xIkivHLIA2LiJMKp21iPbMw8LdmALb2t2SdRLYYSR1gSiLu2GjSPhCn0D18IUeXIhPRUItdMlAlWMFd8NojXsQWol12PBe/VF/Ao+mdmq0lDkiZYkM1+aoFD1NSGOtQO16NWkWoLWtshjYOrmfwRFfhKAyoA7HY9ZOwCD4AelRNXCTYdoKFvoEbaPbnj0GjHrSqlwx26zu8CgDHAvzCGaHr3ifk6d0CaXXjlit0lCG+pi8BuOgda4UFW2CtbQH+j4gktbO6XBv7t4dxB8lJxir6RpN68dFjdOFyZcLkGu/8FXYRsxwT88BPAtCH7sYekrwNSefr3Bls7HZm3njSb2meYnBKubmDHRnhozp9gnvC7tS/eOlKlmYbpFoJX2Q8WgkXno+ILT23o+M/pv3GE27HS0T374AbBs70k= */

const props = __props;

const sections = ref([false, false, false, false]);

const toggleSection = (index: number) => {
  for (let i = 0; i < sections.value.length; i++) {
    if (i === index) {
      sections.value[i] = !sections.value[i];
    } else {
      sections.value[i] = false;
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BottomSheet, {
    "dialog-id": props.dialogId,
    "all-draggable": false,
    "out-side-closable": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(PrimaryLabel, {
          text: "Comment jouer ?",
          class: "mb-2"
        }),
        _createVNode(ModalText, { class: "px-8 text-left" }, {
          default: _withCtx(() => [
            _createElementVNode("ol", _hoisted_2, [
              _createElementVNode("li", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSection(0))),
                onTouch: _cache[1] || (_cache[1] = ($event: any) => (toggleSection(0)))
              }, [
                _hoisted_3,
                (sections.value[0])
                  ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                  : (_openBlock(), _createElementBlock("i", _hoisted_5)),
                (sections.value[0])
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_6, _hoisted_11))
                  : _createCommentVNode("", true),
                _hoisted_12
              ], 32),
              _createElementVNode("li", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSection(1))),
                onTouch: _cache[3] || (_cache[3] = ($event: any) => (toggleSection(1)))
              }, [
                _hoisted_13,
                (sections.value[1])
                  ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                  : (_openBlock(), _createElementBlock("i", _hoisted_15)),
                (sections.value[1])
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_16, _hoisted_20))
                  : _createCommentVNode("", true),
                _hoisted_21
              ], 32),
              _createElementVNode("li", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleSection(2))),
                onTouch: _cache[5] || (_cache[5] = ($event: any) => (toggleSection(2)))
              }, [
                _hoisted_22,
                (sections.value[2])
                  ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                  : (_openBlock(), _createElementBlock("i", _hoisted_24)),
                (sections.value[2])
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_25, _hoisted_28))
                  : _createCommentVNode("", true),
                _hoisted_29
              ], 32),
              _createElementVNode("li", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleSection(3))),
                onTouch: _cache[7] || (_cache[7] = ($event: any) => (toggleSection(3)))
              }, [
                _hoisted_30,
                (sections.value[3])
                  ? (_openBlock(), _createElementBlock("i", _hoisted_31))
                  : (_openBlock(), _createElementBlock("i", _hoisted_32)),
                (sections.value[3])
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_33, _hoisted_41))
                  : _createCommentVNode("", true),
                _hoisted_42
              ], 32)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["dialog-id"]))
}
}

})